import ScrollMagic from 'scrollmagic'

const scrollController = new ScrollMagic.Controller()
export default scrollController
